// extracted by mini-css-extract-plugin
export default {"card":"iq5X4tcG","image":"syaPeQqQ","mobile":"mobile","icon":"uw1dj4PH","announce":"E5wx5tj7"};